import SvgSpriteWrapper from './svgSpriteWrapper'

export default SvgSpriteWrapper
